// script.js

const mapInner = document.querySelector('.map-inner');
const icons = document.querySelectorAll('.interactive-map__icon-wrapper');
let scale = 1;
const scaleFactor = 0.1; // Adjusts how much the map zooms per scroll
const minScale = 1;
const maxScale = 3;

// Initialize translate values to keep track of panning (if needed)
let translateX = 0;
let translateY = 0;

function handleWheel(event) {
  event.preventDefault(); // Prevents the default scroll behavior

  // Get the bounding rectangle of the container
  const rect = mapInner.getBoundingClientRect();

  // Calculate the cursor's position relative to the container
  const offsetX = event.clientX - rect.left;
  const offsetY = event.clientY - rect.top;

  // Calculate the percentage position of the cursor
  const originX = (offsetX / rect.width) * 100;
  const originY = (offsetY / rect.height) * 100;

  // Set the transform-origin to the cursor's position
  mapInner.style.transformOrigin = `${originX}% ${originY}%`;

  // Determine scroll direction and adjust scale
  if (event.deltaY < 0) {
    // Scrolling up, zoom in
    scale += scaleFactor;
  } else {
    // Scrolling down, zoom out
    scale -= scaleFactor;
  }

  // Clamp the scale between minScale and maxScale
  scale = Math.min(Math.max(scale, minScale), maxScale);

  // Apply the scale transformation to the inner container
  mapInner.style.transform = `scale(${scale})`;
}

// Add the wheel event listener to the map wrapper with passive: false
const container = document.querySelector('.interactive-map__image-wrapper');
container.addEventListener('wheel', handleWheel, { passive: false });

